export const msalConfig = {
    auth: {
        clientId: '5cd0090d-684c-4b38-b267-daa19c47f32c',
        authority:
            'https://login.microsoftonline.com/f687c0f3-9126-45bd-b994-b96df8a19c91',
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: 'sessionStorage',
    },
}

export const powerBiTokenRequest = {
    scopes: ['https://analysis.windows.net/powerbi/api/Report.Read.All'],
}
